import React, { useState } from 'react'
import ReactFullscreen from "react-full-screen";


const ImageFullScreenable = ({ downloadURL, index, }) => {

    const [fullscreen, setFullscreen] = useState(false)

    return (
        <ReactFullscreen enabled={fullscreen}>
            <div className="image-container hidden-xs hidden-sm">
                <img
                    className={fullscreen ? 'img-responsive' : 'margin-bottom-medium pointer'}
                    width={266}
                    height={150}
                    src={downloadURL}
                    alt={`resouce${index}`}
                    onClick={() => setFullscreen(!fullscreen)}
                />
            </div>
        </ReactFullscreen >
    )
}

export default ImageFullScreenable
